import type { JSX } from 'react';
import { Lock } from 'lucide-react';

/**
 * Inline explanation shown where a role cannot act. Use instead of a
 * silently missing or silently disabled control. Renders nothing when
 * `reason` is null (the user is allowed).
 */
export function AccessNotice({ reason, className }: { reason: string | null; className?: string }): JSX.Element | null {
  if (!reason) return null;
  return (
    <p
      role="note"
      data-testid="access-notice"
      className={className}
      style={{
        display: 'flex', alignItems: 'center', gap: 8,
        margin: '0 0 12px', padding: '8px 12px',
        borderRadius: 10, border: '1px solid var(--border)',
        background: 'var(--bg-overlay)', color: 'var(--text-muted)',
        fontSize: '0.8125rem',
      }}
    >
      <Lock width={14} height={14} aria-hidden="true" style={{ flex: 'none' }} />
      <span>{reason}</span>
    </p>
  );
}
